import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";


const initialState = {
    isLoading: false,
    error: null,
    reviews: null,

};

export const getAllReviews = createAsyncThunk(
    "reviews/get_reviews",
    async (productId, { dispatch, getState, rejectWithValue }) => {
        try {
            dispatch(getallreviewsStart());
            const response = await axios.get(
                `productReviews/get_active_reviews.php?productId=${productId}`
            );
            dispatch(getallreviewsSuccess(response?.data?.data));
            return response?.data
        } catch (error) {
            dispatch(getallreviewsfailure(error.response.data.message));
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const AddReviews = createAsyncThunk(
    "reviews/add_review",
    async (reviewData, { dispatch, getState, rejectWithValue }) => {
        try {
            dispatch(getallreviewsStart());
            const response = await axios.post(
                `productReviews/add_review.php`, reviewData
            );
            dispatch(getallreviewsSuccess(response?.data));
            return response?.data
        } catch (error) {
            dispatch(getallreviewsfailure(error.response.data.message));
            return rejectWithValue(error.response.data.message);
        }
    }
);





const reviewsSlice = createSlice({
    name: "reviews",
    initialState,
    reducers: {
        getallreviewsStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getallreviewsSuccess(state, action) {
            state.isLoading = false;
            state.reviews = action.payload;


        },
        getallreviewsfailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },


    },
});

export const {
    getallreviewsStart,
    getallreviewsSuccess,
    getallreviewsfailure,


} = reviewsSlice.actions;

export default reviewsSlice.reducer;
